



























































































































































import { Component } from 'vue-property-decorator';
import { storeService } from '@/shared';
import { Base } from "@/components/common/base";
import { VAction } from '@/models/pagedlistmodel';
import { attachmentService } from '@/shared';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { expenseService} from '@/shared';
import { FileHelper as _file } from '@/helper/file.helper';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Calendar: () => import('@/components/common/app.calendar.vue'),
        VuePdfEmbed,
        SnackBarLoader: () => import('@/components/common/loader.vue'),
    },
})
class OcrReportScreen extends Base {
    public fromDate = '';
    public toDate = '';
    public fromSplitDate = '';
    public toSplitDate = '';
    public searchText: string = '';
    public reportData: any[] = [];
    public isReportLoading: boolean = false;
    public isPdfsLoading: boolean = false;
    public actions: VAction[] = [];
    public ocrRecordFilter = ["Expense", "VehicleInvoice"];
    public selectedOcrFilter: string = "VehicleInvoice";
    public isPdfLoading: boolean = false;
    public expenseAttachmentLoader: boolean = false;
    public currentFileName: string = '';
    public currentUri: string = '';
    public downloadAttachmentUri: string = null;
    public attachmentUri: string = null;
    public openAttachmentDialog: boolean = false;
    public invoiceFullScreenLoader: boolean = false;
    public fullScreenAttachmentUri: string = null;
    public invoiceFullScreen: boolean = false;
    public scannedInvoiceLoader: boolean = false;

    public created(): void {
        this.fromDate = this.subtractDaysFromPresent(1);
        this.toDate = this.presentDate();
    }

    public setCustomerDateParameter(dates: any) {
        if (dates.length > 1) {
            this.fromDate = dates[0];
            this.toDate = dates[1];
        }
    }

    public setSplitDateParameter(dates: any) {
        if (dates.length > 1) {
            this.fromSplitDate = dates[0];
            this.toSplitDate = dates[1];
        }
    }

    public headers: any[] = [
        {
            text: '',
            value: '',
            isNotDataProp: true,
            width: '60px',
            sortable: false
        },
        { text: "Document Id", value: "recordKey", sortable: true }
    ];

    public childHeaders: any[] = [
        { text: "Platform", value: "source" },
        { text: "PO Number", value: "poNumber" },
        { text: "Invoice Number", value: "invoiceNumber" },
        { text: "Invoice Date", value: "invoiceDate" },
        { text: "Total", value: "invoiceTotal" },
        { text: "Vendor Address", value: "vendorRemitAddress" },
        { text: "Vendor Name", value: "vendorOcrName" },
        { text: "Phone", value: "vendorPhoneNumber" }
    ];

    public vehicleChildHeaders: any[] = [
        { text: "Platform", value: "source" },
        { text: "VIN", value: "vin" },
        { text: "Order Number", value: "orderNumber" },
        { text: "WholeSale Total Cost", value: "wholeSaleTotalCost" },
        { text: "MSRP", value: "msrpTotalCost" },
        { text: "Customer Name", value: "customerName" },
        { text: "SalesPerson", value: "salesPerson" },
        { text: "Model", value: "Model" },
        { text: "Model Code", value: "modelCode" },
        { text: "Color", value: "color" },
        { text: "Color Code", value: "colorCode" },
        { text: "Trim Color", value: "trimColor" },
        { text: "Trim Code", value: "trimCode" },
        { text: "Base Retail", value: "baseRetail" },
        { text: "Holdback", value: "holdback" },
        { text: "Floorplan Assistance", value: "floorplanAssistance" },
        { text: "Destination And Delivery Fee", value: "destinationAndDeliveryFee" },
    ];



    public splitPdfHeaders: any[] = [
        {
            text: '',
            value: '',
            isNotDataProp: true,
            width: '60px',
            sortable: false
        },
        {
            text: "File Name",
            value: "FileName",
            sortable: false
        },
        {
            text: 'action',
            value: '',
            isNotDataProp: true,
            width: '60px',
            sortable: false
        },
    ];

    public splitPdfChildHeaders: any[] = [
        {
            text: "File Name",
            value: "fileName",
            sortable: false
        },
        {
            text: 'action',
            value: '',
            isNotDataProp: true,
            width: '60px',
            sortable: false
        },

    ];


    public setActions() {
        this.actions = [
            {
                type: 'button',
                icon: 'fas fa-eye',
                title: this.$parent.$t(
                    'scannedInvoices.gridHeaders.gridAction.view'
                ) as string,
                loading: false,
                action: (model: any) => {
                    const fileName = model.FileName || model.fileName;

                    const url = model.ParentUrl
                        || model.parentUrl
                        || model.ChildUrl
                        || model.childUrl;

                    this.openAttachment(fileName, url);
                },
            },
            {
                type: 'button',
                icon: 'fas fa-download',
                title: this.$parent.$t(
                    'scannedInvoices.gridHeaders.gridAction.download'
                ) as string,
                loading: false,
                action: (model: any) => {
                    const url = model.ParentUrl
                        || model.parentUrl
                        || model.ChildUrl
                        || model.childUrl;
                    this.downloadFile(url);
                },
            },
        ];
    }

    public async downloadFile(attachmentUri: string): Promise<void> {
        try {
            this.scannedInvoiceLoader = true;
            const attachment = await expenseService.downloadAttachmentAsync(
                attachmentUri
            );
            const bytes = _file.base64ToArrayBuffer(attachment.fileContents);

            _file.downloadBytes(bytes, '', attachment.fileDownloadName);
        } catch (e) {
            this.showAlert(false, this.$t('scannedInvoices.alertAttachmentNotFound'));
        } finally {
            this.scannedInvoiceLoader = false;
        }
    }
    public async openInvoiceFullScreen() {

        this.isPdfLoading = true;
        this.invoiceFullScreenLoader = true;
        this.fullScreenAttachmentUri = await await this.getAttachmentByFileName(this.currentFileName, this.currentUri);
        this.openAttachmentDialog = false;
        this.invoiceFullScreenLoader = false;
        this.invoiceFullScreen = true;

    }

    public onPdfRendered() {
        this.isPdfLoading = false;
    }

    public async getAttachmentByFileName(name: string, uri: string) {
        var response = await attachmentService.getSplitAttachmentsAsync(name, uri, this.userSession.storeId, this.userSession.enterpriseId, this.userSession.tenantId
        );
        return response.absolutePathUri;
    }
    public async openAttachment(name: string, uri: string): Promise<void> {

        try {
            if (!uri) {

                this.showAlert(false, 'File uri not found');

                return;
            }
            this.isPdfLoading = true;
            this.expenseAttachmentLoader = true;

            this.currentFileName = name;
            this.currentUri = uri;
            this.downloadAttachmentUri = uri;

            this.attachmentUri = await this.getAttachmentByFileName(name, uri);
            this.openAttachmentDialog = true;

        } finally {

            this.expenseAttachmentLoader = false;
        }
    }
    public splitPdfReportData: any[] = [];
    public async mounted() {
        this.$root.$emit('sidebar.layout.vue', 'OCRComaprison');
        await this.getReport();
        this.setActions();
    }

    get filteredReportData(): any[] {
        if (!this.searchText) return this.reportData;

        const search = this.searchText.toLowerCase();

        return this.reportData.filter((item: any) => {

            if (item.recordKey?.toLowerCase().includes(search)) {
                return true;
            }

            return item.children?.some((child: any) =>
                Object.values(child).some((value: any) =>
                    value && value.toString().toLowerCase().includes(search)
                )
            );
        });
    }
    public async getReport(): Promise<void> {
        try {
            this.isReportLoading = true;

            const response = await storeService.getExpenseOcrResult(
                this.userSession.storeId,
                this.fromDate,
                this.toDate,
                this.selectedOcrFilter
            );

            this.reportData = response.results.map((item: any) => {
                const superAi = item.superAiResponse ? JSON.parse(item.superAiResponse) : null;
                const gemini = item.geminiResponse ? JSON.parse(item.geminiResponse) : null;

                if (this.selectedOcrFilter == "Expense") {
                    return {
                        recordKey: gemini?.SuperAiDataPoint,
                        children: [
                            {
                                source: "SuperAI",
                                poNumber: superAi?.["invoice-1PoNumber"]?.[0]?.content,
                                invoiceNumber: superAi?.["invoice-1InvoiceNumber"]?.[0]?.content,
                                vendorRemitAddress: superAi?.["invoice-1ConsignorAddress"]?.[0]?.content,
                                vendorPhoneNumber: superAi?.["invoice-1Mc7Eurpr"]?.[0]?.content,
                                vendorOcrName: superAi?.["invoice-1ConsignorName"]?.[0]?.content,
                                invoiceTotal: superAi?.["invoice-1TotalAmount"]?.[0]?.content,
                                invoiceDate: superAi?.["invoice-1InvoiceDate"]?.[0]?.content
                            },
                            {
                                source: "Gemini",
                                poNumber: gemini?.PO_Number,
                                invoiceNumber: gemini?.Invoice_Number,
                                vendorRemitAddress: gemini?.Vendor_Address,
                                vendorPhoneNumber: gemini?.Vendor_PhoneNumber,
                                vendorOcrName: gemini?.Vendor_Name,
                                invoiceTotal: gemini?.Total_Amount,
                                invoiceDate: gemini?.Invoice_Date
                            }
                        ]

                    };
                }
                else {
                    return {
                        recordKey: gemini?.SuperAiDataPoint,
                        children: [
                            {
                                source: "SuperAI",
                                vin: superAi?.["custom-181Up1Tsu"]?.[0]?.Content,
                                orderNumber: superAi?.["custom-13Pw36Jv3"]?.[0]?.Content,
                                wholeSaleTotalCost: superAi?.["custom-10Gntfmre"]?.[0]?.Content,
                                msrpTotalCost: superAi?.["custom-16Vil0Hkt"]?.[0]?.Content,
                                customerName: superAi?.["custom-1V57Q9Pas"]?.[0]?.Content,
                                salesPerson: superAi?.["custom-1Cp4Kc5X1"]?.[0]?.Content,
                                model: superAi?.["custom-1Y0Oi25Pb"]?.[0]?.Content,
                                modelCode: superAi?.["custom-1Fhi2Rw1T"]?.[0]?.Content,
                                color: superAi?.["custom-1Fwfqfkc8"]?.[0]?.Content,
                                colorCode: superAi?.["custom-1Tu7Dqgi7"]?.[0]?.Content,
                                trimColor: superAi?.["custom-1Qoqakx3U"]?.[0]?.Content,
                                trimCode: superAi?.["custom-1Lnfn2Yl7"]?.[0]?.Content,
                                baseRetail: superAi?.["custom-18X8B6P5U"]?.[0]?.Content,
                                holdback: superAi?.["custom-19Bijp89M"]?.[0]?.Content,
                                floorplanAssistance: superAi?.["custom-14Uh66Xt9"]?.[0]?.Content,
                                destinationAndDeliveryFee: superAi?.["custom-1DestinationAndDeliveryFeeMlfcxrca"]?.[0]?.Content,
                            },
                            {
                                source: "Gemini",
                                vin: gemini?.VIN,
                                orderNumber: gemini?.Order_Number,
                                wholeSaleTotalCost: gemini?.WholeSale_Total_Cost,
                                msrpTotalCost: gemini?.MSRP_Total_Cost,
                                customerName: gemini?.Customer_Name,
                                salesPerson: gemini?.SalesPerson,
                                model: gemini?.Model,
                                modelCode: gemini?.Model_Code,
                                color: gemini?.Color,
                                colorCode: gemini?.Color_Code,
                                trimColor: gemini?.Trim_Color,
                                trimCode: gemini?.Trim_Code,
                                baseRetail: gemini?.Base_Retail,
                                holdback: gemini?.Holdback,
                                floorplanAssistance: gemini?.Floorplan_Assistance,
                                destinationAndDeliveryFee: gemini?.Destination_And_Delivery_Fee,
                            }
                        ]

                    };
                }

            });

        } catch (error) {
            console.error("Error fetching report:", error);
        } finally {
            this.isReportLoading = false;
        }
    }


    public async getSplitPdfs(): Promise<void> {
        try {

            this.isPdfsLoading = true;

            const response = await storeService.getSplitPdfsResult(
                this.fromSplitDate,
                this.toSplitDate,
                this.userSession.storeId,
                this.userSession.enterpriseId,
                this.userSession.tenantId
            );

            this.splitPdfReportData = response.results.map((item: any) => {
                return {
                    FileName: item.fileName,
                    ParentUrl: item.parentUrl,
                    ChildFiles: item.childFiles || []
                };
            });

        } catch (error) {

            console.error("Error fetching split pdfs:", error);

        } finally {

            this.isPdfsLoading = false;
        }
    }
}

export default OcrReportScreen;
